import { FC, useEffect, useState } from "react"
import { BaseModalWindow, IButton } from "../../../components/modalWindows/BaseModalWindow"
import { useAppContext } from "../../../system/providers/appContextProvider"
import { LotDataProvider } from "../../../Services/DataProviders/LotDataProvider"
import { ILotDTO } from "../../../libs/coreapi-dto/accounting/lot"
import GridSelectorInput from "../../../components/controls/GridSelectorInput"
import { useTranslation } from "react-i18next"
import FinancialSecuritySelectorModal from "./FinancialSecuritySelectorModal"
import { IEntitySimpleDTO } from "../../../libs/coreapi-dto/@types/common"

interface IFinancialSecurityModalProps {
    cancel: IButton
    idLotGlobal: string
}

export const FinancialSecurityModalWindow: FC<IFinancialSecurityModalProps> = (props) => {
    const appContext = useAppContext()    
    const lotProvider = new LotDataProvider(appContext.coreApiService) 
    const [lot, setLot] = useState<ILotDTO>();
    const [financialSecurity, setFinancialSecurity] = useState<IEntitySimpleDTO>()
    const { t } = useTranslation();
    const baseT = (value: string) => t("directory.financialSecurity." + value);

    useEffect(() => {
        lotProvider.getById(props.idLotGlobal, (lot) => {
            setLot(lot)
            if (lot.financialSecurity?.idGlobal) {
                setFinancialSecurity(lot.financialSecurity)
            }
        })
    }, [])


    const onSave = () => {
        if (financialSecurity?.idGlobal) {
            lotProvider.attachFinancialSecurity(props.idLotGlobal, financialSecurity.idGlobal as string, () => {
                props.cancel.onClick()
            })
        } else {
            lotProvider.detachFinancialSecurity(props.idLotGlobal, () => {
                 props.cancel.onClick()
            })
        }
    }
    
    return (
         <BaseModalWindow
            header={baseT('title')}
            ok={
                {
                    onClick() {
                        onSave()
                    },
                    title: baseT('saveAndClose')
                } as IButton
            }
            cancel={{ ...props.cancel, title: baseT('close') }}
            footerStyle='customStyles'
        >

            <GridSelectorInput
                    id="idFinancialSecurity"
                    label={baseT('title')}
                    selectorModalJsx={FinancialSecuritySelectorModal}
                    selectedEntity={financialSecurity}
                    onSelect={(entity) => {
                        setFinancialSecurity(entity)
                    }}
                onClear={() => {
                    setFinancialSecurity(undefined)
                }}
            />

        </BaseModalWindow>
    )
}